import DropdownFilter from 'main/components/tables/interactive/components/dropdown_filter/DropdownFilter';

export default DropdownFilter;
